export default __webpack_public_path__ + "static/media/fruiting.2ef5ed78.svg";